module.exports = __webpack_public_path__ + "img/visa-secure.df44ffcb.png";